import routes from "../../common/routes";
import useRouter from "../../common/hooks/useRouter";
import get from "lodash/get";

function useUserOrderPath() {
  const router = useRouter();
  const {orderId} = router.query;

  function goTo(pathname, options) {
    const query = get(options, "query", {});
    const url = {pathname: pathname, params: {orderId, ...query}};
    if (options && options.replace) {
      router.replace(url);
    } else {
      router.push(url);
    }
  }

  function goToUserOrder(orderId, options = {}) {
    goTo(routes.orderDetail, {...options, query: {orderId, ...options.query}});
  }

  function goToUserOrderRating(orderId, options = {}) {
    goTo(routes.userOrderRating, {...options, query: {orderId, ...options.query}});
  }

  function goToUserOrderTip(orderId, options = {}) {
    goTo(routes.userOrderTip, {...options, query: {orderId, ...options.query}});
  }

  return [orderId, goToUserOrder, goToUserOrderRating, goToUserOrderTip];
}

export default useUserOrderPath;
